import LoginNewPassword from './LoginNewPassword';

export default LoginNewPassword;
